const tables = [
  {
    name: "Name",
  },
  {
    name: "Code",
  },
  {
    name: "Type",
  },
   {
    name: "Product Category",
  },
  {
    name: "Rate",
  },
  {
    name: "Applicable On",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;